module.exports = __webpack_public_path__ + "img/swipe.9f9f1b96.png";